import type { ReactNode } from 'react';
import { useWootric } from '@/hooks/useWootric';
import type { WootricUser } from '@/types/wootric';

interface WootricProviderProps {
  children: ReactNode;
  user: WootricUser | null;
  enabled?: boolean;
  wootricToken?: string;
}

export function WootricProvider({ children, user, enabled = true, wootricToken }: WootricProviderProps) {
  useWootric({ user, enabled, wootricToken });

  return <>{children}</>;
}
